import { toastr } from 'react-redux-toastr'
import axiosPublicApi from '../main/axios-public'

export function login(values) {
    return submit(values, `/login`)
}

export function signup(values) {
    return submit(values, `/signup`)
}

function submit(values, url) {
    return dispatch => {
        axiosPublicApi.post(url, values)
            .then(resp => {
                dispatch([
                    { type: 'USER_FETCHED', payload: resp.data }
                ])
            })
            .catch(e => {                
                if(e.response && e.response.data.errors){
                    e.response.data.errors.forEach(
                        error => toastr.error('Erro', error))
                } else {
                    toastr.error('Erro', 'Sem retorno do server. e.response:'+e.response)
                }
            })
    }
}

export function logout() {
    return { type: 'TOKEN_VALIDATED', payload: false }
}

export function validateToken(token) {
    return dispatch => {
        if (token) {
            axiosPublicApi.post(`/validateToken`, { token })
                .then(resp => {
                    dispatch({ type: 'TOKEN_VALIDATED', payload: resp.data.valid })
                })
                .catch(e => dispatch({ type: 'TOKEN_VALIDATED', payload: false }))
        } else {
            dispatch({ type: 'TOKEN_VALIDATED', payload: false })
        }
    }
}